import { api } from "../../services/NetworkBase";

export async function GetInvoices(
  startDate,
  endDate,
  orderStatus,
  searchText,
  page
) {
  try {
    let response = await api
      .get(
        `invoices?startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&page=${page}&orderStatus=${orderStatus}`
      )
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetInvoice(invoiceNumber) {
  try {
    let response = await api.get(`invoices/${invoiceNumber}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetEditInvoiceDetails(invoiceNumber) {
  try {
    let response = await api.get(`invoices/edit/${invoiceNumber}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SendInvoiceEmail(invoiceNumber) {
  try {
    let response = await api.get(`invoices/send-email/${invoiceNumber}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateInvoice(invoice) {
  try {
    let response = await api.put("invoices", {
      json: invoice,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
//review
export async function ReviewInvoice(invoice) {
  try {
    let response = await api.put("invoices/review", {
      json: invoice,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GenerateInvoice(invoice) {
  try {
    let response = await api.put("invoices/generate", {
      json: invoice,
    });
    return response;
  } catch (error) {
    throw error;
  }
}


export async function ApplyPaymentsToInvoice(startDate,endDate) {
  try {
    let response = await api
      .put(
        `invoices/apply-payments?startDate=${startDate}&endDate=${endDate}`
      )
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}


export async function DeleteInvoice(invoiceNumber) {
  try {
    let response = await api.delete(`invoices/${invoiceNumber}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

//DeleteInvoiceTransaction
export async function DeleteInvoiceTransaction(invoiceNumber, id) {
  try {
    let response = await api
      .delete(`invoices/${invoiceNumber}/transactions/${id}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateInvoiceTransaction(transaction) {
  try {
    let response = await api.put("invoices/transactions", {
      json: transaction,
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveInvoiceTransaction(transaction) {
  try {
    let response = await api.post("invoices/transactions", {
      json: transaction,
    });
    return response;
  } catch (error) {
    throw error;
  }
}
